export default function HeadphoneIcon() {
  return (
    <svg width="62" height="50" viewBox="0 0 62 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.0071 9.70088C43.6535 10.2818 42.9084 10.4712 42.3149 10.1428C38.8548 8.28649 34.9653 7.31413 31 7.31413C27.0347 7.31413 23.2589 8.26123 19.824 10.0671C19.2178 10.3828 18.4728 10.1934 18.1318 9.61248L16.1997 6.35437C15.8335 5.74821 16.0355 4.94002 16.6669 4.59906C21.0616 2.23758 25.9866 1 31 1C36.0134 1 41.0773 2.27544 45.5099 4.70007C46.1286 5.04103 46.3307 5.84926 45.9645 6.45541L44.0071 9.70088Z"
        stroke="#505050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.423 23.7309C53.895 16.9117 50.3465 11.0522 45.5856 7.08691"
        stroke="#505050"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.5533 6.95996C11.7167 10.9252 8.11764 16.8353 6.577 23.7303"
        stroke="#505050"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.74349 41.41C3.6472 41.41 1.95502 39.7178 1.95502 37.6215V27.5189C1.95502 25.4227 3.6472 23.7305 5.74349 23.7305C7.83978 23.7305 9.53197 25.4227 9.53197 27.5189V37.6215C9.53197 39.7178 7.83978 41.41 5.74349 41.41Z"
        stroke="#D48136"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.2565 41.41C54.1602 41.41 52.468 39.7178 52.468 37.6215V27.5189C52.468 25.4227 54.1602 23.7305 56.2565 23.7305C58.3528 23.7305 60.045 25.4227 60.045 27.5189V37.6215C60.045 39.7178 58.3528 41.41 56.2565 41.41Z"
        stroke="#D48136"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6346 19.4634C22.8169 16.4074 27.2241 14.6268 32.0481 14.9299C40.2691 15.435 46.8863 22.0522 47.3915 30.2732C47.985 39.8075 40.4207 47.7381 31.0126 47.7381C28.5501 47.7381 26.2265 47.195 24.1302 46.2227L18.3844 49.0009L18.8769 42.3837C16.2123 39.4665 14.5959 35.5897 14.5959 31.3213C14.5959 28.5936 15.2652 26.0049 16.4396 23.7444"
        stroke="#505050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24.6859 27.5195H37.3141" stroke="#D48136" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24.6859 35.0967H33.5256" stroke="#D48136" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
